
/**
 * Analytics service for tracking page views and events
 */
import ReactGA from 'react-ga4';

/**
 * Initialize Google Analytics with the measurement ID
 * @param measurementId - The Google Analytics measurement ID
 */
export const initGA = (measurementId: string): void => {
  if (measurementId) {
    ReactGA.initialize(measurementId);
    console.log('Google Analytics initialized with ID:', measurementId);
  } else {
    console.warn('Google Analytics initialization skipped: No measurement ID provided');
  }
};

/**
 * Track page views
 * @param path - The current path or URL to track
 */
export const trackPageView = (path: string): void => {
  ReactGA.send({ hitType: "pageview", page: path });
  console.log('Page view tracked:', path);
};

/**
 * Track custom events
 * @param category - Event category
 * @param action - Event action
 * @param label - Event label (optional)
 * @param value - Event value (optional)
 */
export const trackEvent = (
  category: string, 
  action: string, 
  label?: string, 
  value?: number
): void => {
  ReactGA.event({
    category,
    action,
    label,
    value,
  });
  console.log('Event tracked:', { category, action, label, value });
};
